import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Spin, Typography } from 'antd';
import {
  HomeOutlined,
  AppstoreOutlined,
  CalendarOutlined,
  LineChartOutlined,
  FundProjectionScreenOutlined,
  MoreOutlined,
  CommentOutlined
} from '@ant-design/icons';
import './SiderComponent.css';
import Sider from 'antd/es/layout/Sider';
import { Sentinel } from './model_gen/sentinel';
import SentinelComponent from './SentinelComponent';
import { Application } from './model_gen/application';
import { SentinelService } from './services/SentinelService';
import { usePermissions } from './PermissionsProvider';
import ConfigComponent from './ConfigComponent';

// Define the props interface
interface LeftSiderComponentProps {
  mappedApplication: Application | undefined;
  loadingApplication: boolean;
  considerTourStep: (step: number) => void;
  tripFault: (sentinel: Sentinel) => void;
  models: string[];
  setModels: (models: string[]) => void;
  temperature: number;
  setTemperature: (temperature: number) => void;
  evaluations: boolean;
  setEvaluations: (evaluations: boolean) => void;
  autocorrect: boolean;
  setAutocorrect: (autocorrect: boolean) => void;
  retrieveContext: boolean;
  setRetrieveContext: (retrieveContext: boolean) => void;
  streaming: boolean;
  setStreaming: (streaming: boolean) => void;
}

const LeftSiderComponent: React.FC<LeftSiderComponentProps> = ({ mappedApplication, loadingApplication, considerTourStep, tripFault, models, setModels, temperature, setTemperature, evaluations, setEvaluations, autocorrect, setAutocorrect, retrieveContext, setRetrieveContext, streaming, setStreaming }) => {
  const { apiKey } = usePermissions();
  const [sentinels, setSentinels] = useState<Sentinel[]>([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (mappedApplication) {
      setLoading(true);
      
      SentinelService.getSentinels(mappedApplication.id!, setLoading, apiKey).subscribe({
        next: (response: any) => {
          
          // Backend returns tuple: [sentinels, count]
          let sentinelData: Sentinel[] = [];
          
          if (Array.isArray(response)) {
            if (response.length > 0 && Array.isArray(response[0])) {
              // Response is [sentinels[], count]
              sentinelData = response[0];
            } else {
              // Response is just sentinels[]
              sentinelData = response;
            }
          } else if (response && response.data) {
            // Response is {data: sentinels[]}
            sentinelData = response.data;
          }
          
          
          // Only show Sentinels with severity > 3
          const activeSentinels = sentinelData.filter((sentinel: Sentinel) => {
            return sentinel.severity >= 3;
          });
          
          setSentinels(activeSentinels);
          setLoading(false);
        },
        error: (error: any) => {
          console.error("Error fetching sentinels:", error);
          setLoading(false);
        },
        complete: () => {
          console.log("Sentinel fetch complete");
          setLoading(false);
        }
      });
    } else {
      console.log("No application selected, cannot fetch sentinels");
    }
  }, [mappedApplication, apiKey]);
  
  const SiderContent = () => (
    <div className={`left-sider-content ${isMobile ? 'mobile' : ''}`}>
      {!isMobile && (
        <Typography style={{
          fontSize: "20px", 
          fontWeight: "700", 
          color: "rgba(0,0,0,0.2)",
          textAlign: "center", 
          marginBottom: "20px"
        }}>
          Configuration
        </Typography>
      )}
      <ConfigComponent 
        models={models} 
        setModels={setModels} 
        temperature={temperature} 
        setTemperature={setTemperature} 
        evaluations={evaluations} 
        setEvaluations={setEvaluations} 
        autocorrect={autocorrect} 
        setAutocorrect={setAutocorrect} 
        retrieveContext={retrieveContext} 
        setRetrieveContext={setRetrieveContext}
        streaming={streaming}
        setStreaming={setStreaming}
      />
      {/* <hr style={{margin: "30px 0", color: "rgba(0,0,0,0.1)", border: "1px solid rgba(0,0,0,0.02)"}} />
      <Typography style={{
        fontSize: "20px", 
        fontWeight: "700", 
        color: "rgba(0,0,0,0.2)", 
        textAlign: "center", 
        marginBottom: "20px"
      }}>
        Sentinels
      </Typography>
      <div style={{marginBottom: '10px'}}>
        {loading && 
          <Typography style={{textAlign: 'center'}}>Loading sentinels...</Typography>
        }
      </div>
      {(sentinels.length > 0) ? (
        <Menu mode="vertical" style={{marginTop: '10px'}}>
          {sentinels?.map((sentinel, index) => (
            <SentinelComponent key={sentinel.id} sentinel={sentinel}/>
          ))}
        </Menu>
      ) : (
        <div style={{
          width: '100%', 
          height: 'auto', 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          background: 'rgba(0,0,0,0.05)', 
          borderRadius: '10px', 
          padding: isMobile ? 20 : 40
        }}>
          {loading || loadingApplication ? (
            <Spin size="large" />
          ) : (
            <Typography style={{
              fontSize: isMobile ? '16px' : '18px', 
              color: 'rgba(0,0,0,0.2)', 
              textAlign: 'center'
            }}>
              {mappedApplication ? "No active sentinels with severity >= 3" : "Choose an application to see applicable Sentinels"}
            </Typography>
          )}
        </div>
      )} */}
    </div>
  );
  
  // If rendered within a drawer, don't use Sider component
  if (isMobile) {
    return <SiderContent />;
  }
  
  return (
    <Sider width={400} className='LeftSider'>
      <SiderContent />
    </Sider>
  );
}

export default LeftSiderComponent;

